import { redirect } from "react-router-dom";
import { loginSelector } from './store/slices/loginSlice';
import store from './store/store';

// для предотвращения перехода по url без авторизации
export async function authLoader({ request }) {
    const url = new URL(request.url);
    // Получаем состояние из Redux
    const state = store.getState();
    // Извлекаем токен и статус статус логина из состояния
    const { token, isSuccess} = loginSelector(state);
    // Если токен отсутствует и пользователь не авторизован, перенаправляем на страницу логина
    if ((!token || token==='') && !isSuccess) {
      return redirect(`/login?redirect=${encodeURIComponent(url.pathname)}`);
    }
    return null;
  }